import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** All the feature products that can be seen in Admin Panel */
export const AllFeatures = [
  "global-face-blurring",
  "ai-indexing",
  "ft_spotwalk",
  "ft_download_360",
  "ft_project_evaluation",
  "project-progress",
  "insights-teaser",
  "global-videomode",
  "global-progress-ai",
  "global-pointcloud-sendto",
  "sphere-dashboard",
  "photogrammetry",
  "videomode-pointclouds",
  "project-export",
  "object-detection",
  "focus-orbis-staging-area-workflows",
  "sitescape-workflow",
  "core-product",
] as const satisfies readonly FaroCoreApiTypes.FeatureIdentifier[];
export type AllFeaturesTypes = (typeof AllFeatures)[number];

/** All the bundle products that can be seen in Admin Panel */
export const AllBundles = [
  "dashboard",
  "edu",
  "plan-fm",
  "premium-insights",
  "gps",
  "snapshot",
  "vpm",
  "vpm-enterprise",
  "pointcloud",
  "cloud-processing",
  "cad",
  "flash",
  "faro-stream",
  "floorplan-generator",
  "minimal",
  "hb-to-sxg-migrated",
] as const satisfies readonly FaroCoreApiTypes.BundleIdentifier[];
export type AllBundlesTypes = (typeof AllBundles)[number];

/**
 * The legacy HoloBuilder plans. They are modelled as bundles, but they are sold as
 * subscriptions that grant access to HoloBuilder, so they are offered next to the
 * Sphere XG plans instead of next to the features.
 */
export const AllHoloBuilderLegacyPlans = [
  "plan-fm",
  "edu",
  "vpm-enterprise",
] as const satisfies readonly AllBundlesTypes[];

/** All the subscription products that can be seen in Admin Panel */
export const AllSubscriptions = [
  "sphere-xg-standard",
  "sphere-xg-pro",
  "sphere-xg-enterprise",
] as const satisfies readonly FaroCoreApiTypes.BundleIdentifier[];
export type AllSubscriptionsTypes = (typeof AllSubscriptions)[number];

/** All the addon products that can be seen in Admin Panel */
export const AllAddons = [
  "sphere-xg-addon-360",
  "sphere-xg-addon-point-cloud",
] as const satisfies readonly FaroCoreApiTypes.BundleIdentifier[];
export type AllAddonsTypes = (typeof AllAddons)[number];

/** All the custom SphereXG products in Admin Panel */
export const AllSphereXgProducts = [
  "standard360",
  "standardPointCloud",
  "pro360",
  "proPointCloud",
  "enterprise360",
  "enterprisePointCloud",
  "enterprise360PointCloud",
] as const;

/**
 * Backend bundle identifiers for the 2026 Sphere XG plans. These are not yet part
 * of the client's BundleIdentifier enum, so they are declared here as string literals.
 */
export const AllSphereXg2026Bundles = [
  "sphere-xg-2026-scan-free",
  "sphere-xg-2026-scan-starter",
  "sphere-xg-2026-scan-essential",
  "sphere-xg-2026-scan-professional",
  "sphere-xg-2026-scan-enterprise",
] as const;
export type AllSphereXg2026BundlesTypes =
  (typeof AllSphereXg2026Bundles)[number];

/** All the custom SphereXG 2026 products in Admin Panel */
export const AllSphereXg2026Products = [
  "scanFree2026",
  "scanStarter2026",
  "scanEssential2026",
  "scanProfessional2026",
  "scanEnterprise2026",
] as const;

/** All the custom SphereXG products across every plan year */
export const AllSphereXgProductsAllYears = [
  ...AllSphereXgProducts,
  ...AllSphereXg2026Products,
] as const;

/** All the custom credit products that can be seen in Admin Panel */
export const AllCreditProducts = [
  "addCredits",
  "addCreditsSmall",
  "addCreditsMedium",
  "addCreditsLarge",
] as const;

/** All the enterprise products that can be seen in Admin Panel */
export const AllEnterpriseProducts = [
  "enterprise360",
  "enterprisePointCloud",
  "enterprise360PointCloud",
] as const;

/** All the custom products that can be seen in Admin Panel */
export const AllCustomProducts = [
  ...AllSphereXgProducts,
  ...AllSphereXg2026Products,
  ...AllCreditProducts,
] as const;
export type AllCustomProductsTypes = (typeof AllCustomProducts)[number];

/** All the trial products that can be seen in Admin Panel */
export const AllTrialProducts = ["enterprise360PointCloudTrial"] as const;
export type AllTrialProductTypes = (typeof AllTrialProducts)[number];
